import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=c85e5e4e"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"
import style0 from "./ServiceCenter.vue?vue&type=style&index=0&id=c85e5e4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports